document.addEventListener('DOMContentLoaded', function () {
  var lazyImages = [].slice.call(document.querySelectorAll('img[data-img-defer-src]'))

  if ('IntersectionObserver' in window) {
    var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var lazyImage = entry.target
          lazyImage.src = lazyImage.dataset.imgDeferSrc
          delete lazyImage.dataset.imgDeferSrc
          lazyImageObserver.unobserve(lazyImage)
        }
      })
    })

    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage)
    })
  }
})

document.addEventListener('DOMContentLoaded', function () {
  var lazyBGs = [].slice.call(document.querySelectorAll('[data-bg-defer-src]'))

  if ('IntersectionObserver' in window) {
    var lazyBGObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var lazyBG = entry.target
          lazyBG.setAttribute('style', 'background-image:url(' + lazyBG.dataset.bgDeferSrc + ')')
          delete lazyBG.dataset.bgDeferSrc
          lazyBGObserver.unobserve(lazyBG)
        }
      })
    })

    lazyBGs.forEach(function (lazyBG) {
      lazyBGObserver.observe(lazyBG)
    })
  }
})
